var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpeciality18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c,.d{fill:none;stroke:#208ce1;stroke-linecap:round;stroke-width:1.5px;}.c{stroke-linejoin:round;}.e{fill:#e2e8f3;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-915 -8113)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(915 8113)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-82.13 0.954)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-811.617-8111.954s-1.361,7.917,2.444,7.255c2.722-1.049,10.264-6.85,18.44,0s6.763,19.492,3.92,26.945-11.5,7.28-15.041,7.216c-6.654-.111-11.527-4.944-11.527-4.944"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-818.481-8111.954s-2.745,9.5,7.549,16.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-805.833-8090s6.177,11.177-4.118,8.824-11.275,3.823-9.216,7.549,4.216,3.138,3.039,7.942"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-808.226-8071.964s1.113,2.163.721,6.454"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-808.415-8093.923l.189,3.337-19.373,9.412s-3.754,1-3.219-1.594S-808.415-8093.923-808.415-8093.923Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-808.459-8093.754l12.569-6.549s1.135,4.938-5.281,6.681a34.482,34.482,0,0,0-4.41,1.215,10.058,10.058,0,0,0-2.68,1.828"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M-769.751-8174.435c-4.467-.083-3.916,2.56-5.732,2.882-4.713.84-1.263,3.328-4.923,4.515s-3.53.867-8.475-.148C-783.583-8163.871-774.073-8161.191-769.751-8174.435Z",
    transform: "translate(2601.321 -610.289) rotate(-19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality18);
export default __webpack_public_path__ + "static/media/speciality18.412788efc8c7abeb65c28b0a57b4936b.svg";
export { ForwardRef as ReactComponent };